module.exports = new __parcel__URL__("ambient-background-abstract.e16193e6.svg").toString();